import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import Box from 'suitTheme/Box'
import ListItem from 'suitTheme/ListItem'
import Text from 'suitTheme/Text'
import UserProfileImage from 'suitTheme/UserProfileImage'

const User = (props) => {
  const {
    boxProps,
    children,
    disableHover,
    forceBottomBorder,
    image,
    imageKey,
    onClick,
    subtitle,
    title,
  } = props

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        borderColor: 'lineColor',
        paddingY: 'large',
        ...boxProps,
      }}
      disableHover={disableHover}
      forceBottomBorder={forceBottomBorder}
      onClick={onClick}
    >
      <Box marginRight="medium" width="auto">
        <UserProfileImage image={image} imageKey={imageKey}>
          <FontAwesomeIcon icon={faUser} />
        </UserProfileImage>
      </Box>

      <Box flexDirection="column">
        <Text fontSize="small">{title}</Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
          {subtitle}
        </Text>
      </Box>

      {children}
    </ListItem>
  )
}

User.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  disableHover: PropTypes.bool,
  forceBottomBorder: PropTypes.bool,
  image: PropTypes.object,
  imageKey: PropTypes.string,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default User
